<template functional>
  <!-- eslint-disable -->
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.115,21.749a10.241,10.241,0,0,1-1.454-.1,9.764,9.764,0,0,1-8.34-8.46A9.611,9.611,0,0,1,3.627,7.034h0A9.964,9.964,0,0,1,12.133,2.25a1.09,1.09,0,0,1,.717,1.918A5.725,5.725,0,0,0,15.872,14.2a5.872,5.872,0,0,0,4.159-.975,1.094,1.094,0,0,1,1.253.007,1.08,1.08,0,0,1,.431,1.163A9.854,9.854,0,0,1,12.115,21.749ZM11.085,3.816A8.441,8.441,0,0,0,4.913,7.807h0a8.121,8.121,0,0,0-1.1,5.2,8.262,8.262,0,0,0,7.062,7.154A8.424,8.424,0,0,0,19.943,15a7.479,7.479,0,0,1-4.269.678A7.227,7.227,0,0,1,11.085,3.816ZM4.27,7.42h0Z" />
  </svg>
</template>

<script>
export default {
  name: 'IconMoon',
};
</script>